import * as React from 'react';
import { useEffect } from 'react';

import { DescriptionPage_SelfServeConfiguration_ModuleName as ModuleNames } from '__generated__/graphql-types';

import { useParams } from 'js/lib/useRouter';

import { useTracker } from '@coursera/event-pulse/react';

import {
  useEnterpriseLearningPathName,
  useEnterpriseLearningPathPageData,
} from 'bundles/enterprise-learning-path-description-page/contexts/EnterpriseLearningPathContext';
import { useSkillTagsData } from 'bundles/enterprise-learning-path-description-page/contexts/EnterpriseLearningPathSkillsContext';
import { useVspPageV2Data } from 'bundles/enterprise-learning-path-description-page/hooks/useVspPageV2Data';
import Renderer from 'bundles/enterprise-learning-path-description-page/pages/EnterpriseSkillPathwayPageRenderer';
import EventingDataProvider from 'bundles/enterprise-learning-path-description-page/providers/EventingDataProvider';
import { SKILL_PATHWAY_NAV_ITEMS } from 'bundles/enterprise-learning-path-description-page/utils/getPageNavigationLinks';
import PageInfoProvider from 'bundles/unified-description-page-common/providers/PageInfoProvider';

const EnterpriseSkillPathwayPageRootContent = () => {
  const pageData = useEnterpriseLearningPathPageData();
  const productTitle = useEnterpriseLearningPathName();
  const skillTagsData = useSkillTagsData();
  const { programSlug } = useParams();
  const track = useTracker();

  const courseIds = pageData?.enterpriseBadge.badgeActivities.map((activity) => activity.id);
  const { data: vspPageV2Data, loading: vspPageV2DataLoading } = useVspPageV2Data(courseIds || []);

  useEffect(() => {
    if (pageData?.enterpriseBadge.id) {
      track('view_description_page', {
        product: {
          id: pageData.enterpriseBadge.id,
          verifiedSkillPath: true,
        },
      });
    }
    // this event only needs to be tracked once this component is rendered, hence disabled the rule below
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!pageData || !productTitle || !skillTagsData) {
    return null;
  }

  const pageConfig = {
    modules: [{ name: ModuleNames.Breadcrumbs }, { name: ModuleNames.ProductOverview }, { name: ModuleNames.Syllabus }],
  };

  // const navigationLinks = getSkillPathwayNavigationLinks();

  return (
    <PageInfoProvider programSlug={programSlug} navigationIdMap={SKILL_PATHWAY_NAV_ITEMS}>
      <EventingDataProvider productId={pageData.enterpriseBadge.id} productType="learning_path">
        {/* <PageNavigationProvider navigationLinks={navigationLinks}> */}
        {/* <StickyPanelProvider> */}
        {/* <FixedPageNavigation
              productTitle={productTitle}
              navigationLinks={navigationLinks}
              pageCta={<EnterpriseSkillPathwayEnrollButtonNotConfigurable pageData={pageData} />}
            /> */}
        <Renderer
          pageData={pageData}
          pageConfig={pageConfig}
          skillTagsData={skillTagsData}
          vspPageV2Data={vspPageV2Data}
          vspPageV2DataLoading={vspPageV2DataLoading}
        />
        {/* </StickyPanelProvider> */}
        {/* </PageNavigationProvider> */}
      </EventingDataProvider>
    </PageInfoProvider>
  );
};

export default EnterpriseSkillPathwayPageRootContent;
